import { createJSONStorage, persist } from 'zustand/middleware';
import { create } from 'zustand';

import { createAppSlice } from "./appSlice";

export const useAppStore = create()(
  persist(
    (...a) => ({
      ...createAppSlice(...a),
    }),
    {
      name: 'app-data', // name of item in the storage (must be unique)
      storage: createJSONStorage(() => localStorage), // (optional) by default the 'localStorage' is used
      partialize: (state) => ({
        data: "",
      }),
    },
  ),
);

